module.exports = __webpack_public_path__ + "img/diesel-locomotive-shadow-03.f7307a10.png";